require("./../defenitions/article/componentas/articleComments/site_articleCommentsComponenta.less")
require("./../defenitions/article/componentas/articleComments/calcalist_magazine_yplus_site_articleCommentsComponenta.less")
require("../defenitions/article/componentas/articleComments/ynet1280Comments/app_ynet_yplus_pplus_magazine2025_articleComments.less")

import * as axios from "axios"
import * as uniqBy from "lodash/uniqBy"
import * as take from "lodash/take"
import { ArticleCommentData, SortingOptions, ArticleCommentsStorageState } from "../defenitions/article/componentas/articleComments/interfaces"
import { SiteWebStorage } from "../widgetsUtils"
import { AddCommentFormWrapper, AddCommentFormRender, AddCommentFormRenderProps } from "../defenitions/article/componentas/articleComments/addCommentFormWrapper"
import { AddCommentFormYnetUI } from "../defenitions/article/componentas/articleComments/addCommentFormYnetUI"
import { PremiumAddCommentFormUI } from "../defenitions/article/componentas/articleComments/premiumAddCommentFormUI"
import { ArticleCommentWrapper, ArticleCommentRender, ArticleCommentRenderProps } from "../defenitions/article/componentas/articleComments/articleCommentWrapper"
import { PremiumArticleCommentUI } from "../defenitions/article/componentas/articleComments/premiumArticleCommentUI"
import { ArticleCommentYnetUi } from "../defenitions/article/componentas/articleComments/articleCommentYnetUi"
import { ArticleCommentsTopTabWrapper, ArticleCommentsTopTabRender, ArticleCommentsTopTabRenderProps } from "../defenitions/article/componentas/articleComments/articleCommentsTopTabWrapper"
import { PremiumArticleCommentsTopTabUI } from "../defenitions/article/componentas/articleComments/premiumArticleCommentsTopTabUI"
import { ArticleCommentsTopTabYnetUi } from "../defenitions/article/componentas/articleComments/articleCommentsTopTabYnetUi"
import { addAxiosDateTransformerSettings } from "../../utils/network/axiosDateTransformer";
import { getTranslation } from "../defenitions/article/componentas/articleComments/translations"
import { Grid1280ArticleCommentsTopTabUI } from "../defenitions/article/componentas/articleComments/grid1280ArticleCommentsTopTabUi";
import { CalcalistArticleCommentsTopTabUI } from "../defenitions/article/componentas/articleComments/calcalistCommets/commentsTabUI"
import { CalcalistAddCommentFormUI } from "../defenitions/article/componentas/articleComments/calcalistCommets/calcalistAddCommentFormUI"
import { CalcalistArticleCommentUI } from "../defenitions/article/componentas/articleComments/calcalistCommets/calcalistArticleCommentUI"
import { ArticleCommentsTopTabUI1280 } from "../defenitions/article/componentas/articleComments/ynet1280Comments/ynetArticleCommentsTopTabUI1280";
import { AddCommentFormUI1280 } from "../defenitions/article/componentas/articleComments/ynet1280Comments/ynetAddCommentFormUI1280";
import { ArticleCommentUI1280 } from "../defenitions/article/componentas/articleComments/ynet1280Comments/ynetArticleCommentUI1280"
import { ArticleCommentsTopTabAppUI } from "../defenitions/article/componentas/articleComments/ynet1280Comments/ynetArticleCommentTopTabApp";
import { ArticleCommentAppUI } from "../defenitions/article/componentas/articleComments/ynet1280Comments/ynetArticleCommentAppUI";
import { ArticleCommentMobileWebUI } from "../defenitions/article/componentas/articleComments/ynet1280Comments/mutamArticleCommentAppUI";
import { ArticleCommentsTopTabMobileWebUI } from "../defenitions/article/componentas/articleComments/ynet1280Comments/mutamArticleCommentTopTabUI";
import { MutamArticleCommentsPopupUI } from "../defenitions/article/componentas/articleComments/ynet1280Comments/mutamArticleCommentsPopup";
import { MutamArticleCommentsPopupWrapper, MutamArticleCommentsPopupRenderProps, MutamArticleCommentsPopupRender } from "../defenitions/article/componentas/articleComments/mutamArticleCommentsPropsWrapper";
import { ArticleCommentsCalcalistTopTabMobileWebUI } from "../defenitions/article/componentas/articleComments/ynet1280Comments/mutamArticleCalcalistCommentTopTabUI"
import { ArticleCommentMobileCalcalistWebUI } from "../defenitions/article/componentas/articleComments/ynet1280Comments/mutamArticleCalcalistCommentAppUI";
import { MutamArticleCommentsCalcalistPopupUI } from "../defenitions/article/componentas/articleComments/ynet1280Comments/mutamArticleCommentsCalcalistPopup";
import { AddCommentFormUI2026 } from "../defenitions/article/componentas/articleComments/ynetCommentsTemplate2026/ynetAddCommentFormUI2026"
import { ArticleCommentUI2026 } from "../defenitions/article/componentas/articleComments/ynetCommentsTemplate2026/ynetArticleCommentUI2026"
import { ArticleCommentsTopTabUI2026 } from "../defenitions/article/componentas/articleComments/ynetCommentsTemplate2026/ynetArticleCommentsTopTabUI2026"
import { ArticleCommentsTopTabMobileWebUI2026 } from "../defenitions/article/componentas/articleComments/ynetCommentsTemplate2026/mutamArticleCommentTopTabUI"
import { DesktopArticleCommentsPopupUI } from "../defenitions/article/componentas/articleComments/ynetCommentsTemplate2026/desktopArticleCommentsPopupUI"
import { MutamArticleCommentsPopupU2026 } from "../defenitions/article/componentas/articleComments/ynetCommentsTemplate2026/mutamArticleCommentsPopupUI"
import { ArticleCommentsTopTabAppUI2026 } from "../defenitions/article/componentas/articleComments/ynetCommentsTemplate2026/ynetArticleCommentTopTabApp"
import { ArticleCommentAppUI2026 } from "../defenitions/article/componentas/articleComments/ynetCommentsTemplate2026/ynetArticleCommentAppUI"


interface SiteArticleCommentsProps {
    articleId: string
    lang: string
    isLtr: boolean
    displayType: string
    isGrid1280?: boolean
    version?: number
    showFormWhenEmpty?: boolean
    isGptType: string
    blogArticleItem?: boolean
    postId?: string
    domain?: string
    siteName?: string
}

interface SiteArticleCommentsState {
    comments: ArticleCommentData[]
    teaserComments: ArticleCommentData[]
    numOfDiscussions: number
    numOfComments: number
    isAddCommentFormVisible: boolean
    areAllCommentsExpanded: boolean
    sortSelection: SortingOptions
    IdOfLastTalkbackExpandedByUser: number
    page: number
    hasMore: boolean
    isAllCommentsPopupVisable: boolean
    isPopupClose: boolean
    bodyOverflowState: string

}

declare const window: Window & {
    handleCommentsPopupVisability: () => void
}
export class SiteArticleComments extends React.Component<SiteArticleCommentsProps, SiteArticleCommentsState> {
    public static siteScriptName = "SiteArticleComments";
    public isWcmCommetnsRecived = false;
    constructor(props) {
        const comments_template_2026 = (typeof window !== "undefined" && window.commentsDisplayType) && window.commentsDisplayType === "comments_template_2026";
        super(props)
        this.state = {
            comments: [],
            numOfDiscussions: 0,
            numOfComments: 0,
            isAddCommentFormVisible: false,
            areAllCommentsExpanded: false,
            sortSelection: comments_template_2026 ? "recommended" : "end_to_start",
            IdOfLastTalkbackExpandedByUser: null,
            page: 0,
            hasMore: false,
            isAllCommentsPopupVisable: false,
            isPopupClose: false,
            bodyOverflowState: "",
            teaserComments: []
        }
    }

    componentDidMount() {
        const { articleId, showFormWhenEmpty } = this.props
        const articleCommentsState: ArticleCommentsStorageState = SiteWebStorage.getSessionStorageItem("articleCommentsState");
        if (articleCommentsState && (articleCommentsState.articleId === articleId)) {
            this.setState({
                areAllCommentsExpanded: articleCommentsState.areAllCommentsExpanded,
                sortSelection: articleCommentsState.sortSelection,
                IdOfLastTalkbackExpandedByUser: articleCommentsState.IdOfLastTalkbackExpandedByUser,
                page: 0,
            })
            this.getCommentsData(articleCommentsState.sortSelection);
        }
        else {
            this.getCommentsData((typeof window !== "undefined" && window.commentsDisplayType) && window.commentsDisplayType === "comments_template_2026" ? "recommended" : "end_to_start");
        }

        if (typeof window !== "undefined") {
            if (this.props.postId) {
                window[`handleCommentsPopupVisibility_${this.props.postId}`] = this.handleCommentsPopupVisibility
            }
            else window.handleCommentsPopupVisability = this.handleCommentsPopupVisibility

        }
    }

    private getTalkbackNumberView = (tbNumber: number) => {
        const stringNumber = tbNumber.toString()
        let number = stringNumber

        if (stringNumber.length > 3) {
            number = stringNumber.charAt(0) + "k"
        } else if (stringNumber.length > 4) {
            number = stringNumber.charAt(0) + stringNumber.charAt(1) + "k"
        } else if (parseInt(stringNumber) === 0) {
            number = "";
        }

        return number
    }

    private updateArticleCommentsStorageState = (talkbackId = null, allCommentsExpanded?) => {
        const { articleId } = this.props
        const { areAllCommentsExpanded, sortSelection, IdOfLastTalkbackExpandedByUser } = this.state
        const plainArticleCommentsState: ArticleCommentsStorageState = {
            articleId,
            areAllCommentsExpanded: allCommentsExpanded || areAllCommentsExpanded,
            IdOfLastTalkbackExpandedByUser: talkbackId || IdOfLastTalkbackExpandedByUser,
            sortSelection,
        }
        SiteWebStorage.setSessionStorageItem("articleCommentsState", plainArticleCommentsState)
    }

    private getCommentsData = (sortBy: SortingOptions = "end_to_start", page: number = 0, shouldLoadOneApi = false
    ) => {
        const { articleId, showFormWhenEmpty, postId, displayType } = this.props
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());
        const comments_template_2026 = (typeof window !== "undefined" && window.commentsDisplayType) && window.commentsDisplayType === "comments_template_2026";
        const shouldLoadSingleApi = shouldLoadOneApi || (displayType === "calcalist" && !comments_template_2026) || (displayType === "calclistMobileWeb" && !comments_template_2026);
        const postIdParam = postId ? `post/${postId}/` : '';
        const pageNumber = postId ? 1 : page;
        const api = comments_template_2026 ? `/iphone/json/api/talkbacks/list/v2/${articleId}/${postIdParam}${sortBy}/${pageNumber}` : `/iphone/json/api/talkbacks/list/${articleId}/${postIdParam}${sortBy}/${pageNumber}`;
        const teaserApi = `/iphone/json/api/talkbacks/list/v2/${articleId}/recommended/0`;
        axiosInstance.get(api)
            .then((res: any) => {
                if (res.data.rss.channel && res.data.rss.channel.item) {
                    const comments: ArticleCommentData[] = res.data.rss.channel.item
                    const numOfDiscussions: number = res.data.rss.channel.sum_discussions;
                    const numOfComments: number = res.data.rss.channel.sum_talkbacks;
                    const hasMore: boolean = res.data.rss.channel.hasMore === 1;
                    this.setState((pState) => {
                        const newComments = uniqBy([...pState.comments, ...comments], 'id')
                        return {
                            comments: newComments,
                            numOfDiscussions,
                            numOfComments,
                            hasMore,
                        }
                    })
                }
                else {

                    this.setState({ isAddCommentFormVisible: this.props.showFormWhenEmpty })
                }
                window.wcmNumOfComments = this.getTalkbackNumberView(this.state.numOfComments)
                if (this.props.postId) {
                    window[`wcmNumOfCommentsInPost_${this.props.postId}`] = this.getTalkbackNumberView(this.state.numOfComments);
                }

                if (!this.isWcmCommetnsRecived) {
                    const eventDetail: any = {
                        wcmNumOfComments: window.wcmNumOfComments
                    };

                    // Only add postId data if postId exists
                    if (this.props.postId) {
                        eventDetail[`wcmNumOfCommentsInPost_${this.props.postId}`] = window[`wcmNumOfCommentsInPost_${this.props.postId}`];
                    }

                    document.dispatchEvent(new CustomEvent('onWcmCommetnsRecived', {
                        detail: eventDetail
                    }));
                    this.isWcmCommetnsRecived = true;
                }
            })
        if (!shouldLoadSingleApi) {
            axiosInstance.get(teaserApi)
                .then((res: any) => {
                    if (res.data.rss.channel && res.data.rss.channel.item) {
                        const teaserComments: ArticleCommentData[] = res.data.rss.channel.item
                        this.setState((pState) => {
                            const newTeaserComments = uniqBy([...pState.teaserComments, ...teaserComments], 'id')
                            return {
                                teaserComments: newTeaserComments,

                            }
                        })
                    }
                })
                .catch((error) => {
                    console.error("Error fetching teaser comments:", error);
                })
        };
    }

    private handleSortSelection = (e, page?: number) => {
        const sortSelectionValue = e.target.value as SortingOptions
        this.getCommentsData(sortSelectionValue, page || 0)
        this.setState({
            page: page || 0,
            comments: [],
            sortSelection: sortSelectionValue,
            areAllCommentsExpanded: (sortSelectionValue === "recommended" || sortSelectionValue === "interest") ? true : false
        }, () => this.updateArticleCommentsStorageState(null, false))
    }

    private expandAllComments = (shouldExpandComments: boolean) => {
        this.setState({ areAllCommentsExpanded: shouldExpandComments }, () => this.updateArticleCommentsStorageState())
    }

    private handleFormVisibility = () => {
        this.setState((pState: SiteArticleCommentsState) => {
            return { isAddCommentFormVisible: !pState.isAddCommentFormVisible }
        })
    }

    private handleCloseCommentForm = () => {
        this.setState({ isAddCommentFormVisible: false })
    }

    private handleCommentsPopupVisibility = () => {
        const comments_template_2026 = (typeof window !== "undefined" && window.commentsDisplayType) && window.commentsDisplayType === "comments_template_2026";
        this.setState(state => ({ isAllCommentsPopupVisable: !state.isAllCommentsPopupVisable }), () => {
            if (this.state.isAllCommentsPopupVisable) {
                this.setState({
                    bodyOverflowState: document.querySelector("body").style.overflow,
                    isPopupClose: false
                });
                (document.querySelector("body").style.overflow = comments_template_2026 ? this.state.bodyOverflowState : "hidden");
                if (this.state.hasMore) {
                    this.loadMoreComments();
                }
            } else {
                this.setState({ isPopupClose: true });
                document.querySelector("body").style.overflow = this.state.bodyOverflowState;
            }
        });
    }

    private handleCommentsPopupOpen = () => {
        const comments_template_2026 = (typeof window !== "undefined" && window.commentsDisplayType) && window.commentsDisplayType === "comments_template_2026";
        this.setState({ isAllCommentsPopupVisable: true }, () => {
            if (this.state.isAllCommentsPopupVisable) {
                this.setState({
                    bodyOverflowState: document.querySelector("body").style.overflow,
                    isPopupClose: false
                });
                (document.querySelector("body").style.overflow = comments_template_2026 ? this.state.bodyOverflowState : "hidden");
                if (this.state.hasMore) {
                    this.loadMoreComments();
                }
            } else {
                this.setState({ isPopupClose: true });
                document.querySelector("body").style.overflow = this.state.bodyOverflowState;
            }
        });
    }

    private handleCommentsPopupClose = () => {
        const { sortSelection } = this.state
        if (!this.props.postId) {
            this.setState({ comments: [], page: 0 }, () => {
                this.getCommentsData(sortSelection, 0)
            })
        }

        this.setState({ isAllCommentsPopupVisable: false, isPopupClose: true })

        document.querySelector("body").style.overflow = this.state.bodyOverflowState;
        this.handleCloseCommentForm();
        //  this.onCloseCommentsBtnPress();
    }


    private loadMoreComments = (sortSelectionValue?: SortingOptions, shouldLoadOneApi?: boolean) => {
        const { page, sortSelection } = this.state;
        const nextPage = page + 1;
        this.setState({ hasMore: false });
        this.setState({ page: nextPage }, () => {
            this.getCommentsData(sortSelectionValue ? sortSelectionValue : sortSelection, nextPage, shouldLoadOneApi);
        });
        this.analyticsLoadMoreCommentsPushFunc()
    }

    private analyticsLoadMoreCommentsPushFunc = () => {
        if (typeof window !== "undefined") {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                event: 'comments_events',
                Category: 'Comments',
                Action: 'Watch More Comments'
            });
        }
    }

    private onCloseCommentsBtnPress = () => {
        const { sortSelection } = this.state
        this.setState({ comments: [], page: 0 }, () => {
            this.getCommentsData(sortSelection, 0, true)
            var elmnt = document.getElementById("SiteArticleComments");
            elmnt.scrollIntoView();
        })
    }

    render() {
        const { comments, teaserComments, numOfDiscussions, numOfComments, isAddCommentFormVisible, areAllCommentsExpanded,
            sortSelection, IdOfLastTalkbackExpandedByUser, page, hasMore, isAllCommentsPopupVisable, isPopupClose } = this.state
        const { articleId, lang, isLtr, displayType, isGrid1280, version, showFormWhenEmpty, isGptType, blogArticleItem, postId, domain, siteName } = this.props
        let EnglishSiteCss = isLtr ? "englishSite" : ""
        const comments_template_2026 = (typeof window !== "undefined" && window.commentsDisplayType) && window.commentsDisplayType === "comments_template_2026";
        const isMobile = (typeof window !== "undefined" && window.isMobile1 || displayType === "firmaMobileWeb") && displayType !== "firmaApp";
        const isYnetPlus = displayType === "premium" && !comments_template_2026;
        const calcalist = displayType === "calcalist" && !comments_template_2026;
        const isFirmaDesign = displayType === "firma" && !comments_template_2026;
        const isFirmaApp = displayType === "firmaApp" && !comments_template_2026;
        const isFirmaMobileWeb = displayType === "firmaMobileWeb" && !comments_template_2026;
        const isCalcalistMobileWeb = displayType === "calclistMobileWeb" && !comments_template_2026;
        const isMobileWeb = isCalcalistMobileWeb || isMobile;
        const comments_template_2026_mobile = isMobile && comments_template_2026;
        const comments_template_2026_app = displayType === "firmaApp" && comments_template_2026;
        const comments_template_2026_desktop = displayType !== "firmaApp" && !isMobile && comments_template_2026;
        let AddCommentFormRender: AddCommentFormRender;
        let ArticleCommentRender: ArticleCommentRender;
        let ArticleCommentsTopTabRender: ArticleCommentsTopTabRender;
        let ArticleCommentsPopupRender: MutamArticleCommentsPopupRender;
        let limitComments = 0;
        if (comments_template_2026_desktop) {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => postId ? null : <AddCommentFormUI2026 props={{ ...props, siteName: siteName }} />
            ArticleCommentRender = (props: ArticleCommentRenderProps) => postId ? null : <ArticleCommentUI2026 props={{ ...props, notPopupMode: true }} />
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => postId ? null : <ArticleCommentsTopTabUI2026 props={props} />
            ArticleCommentsPopupRender = (props: MutamArticleCommentsPopupRenderProps) => <DesktopArticleCommentsPopupUI props={{ ...props, siteName: siteName }} />;

        }
        else if (comments_template_2026_mobile) {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => null;
            ArticleCommentRender = (props: ArticleCommentRenderProps) => postId ? null : <ArticleCommentUI2026 props={{ ...props, notPopupMode: true }} />;
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => postId ? null : <ArticleCommentsTopTabMobileWebUI2026 props={props} />;
            ArticleCommentsPopupRender = (props: MutamArticleCommentsPopupRenderProps) => <MutamArticleCommentsPopupU2026 props={{ ...props, siteName: siteName }} />;
        }
        else if (comments_template_2026_app) {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => null,
                ArticleCommentRender = (props: ArticleCommentRenderProps) => version > 2 && !postId ? <ArticleCommentAppUI2026 props={{ ...props, notPopupMode: true }} /> : null,
                ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => version > 2 && !postId ? <ArticleCommentsTopTabAppUI2026 props={props} /> : null
        }
        else if (isYnetPlus) {
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => isGrid1280 ? <Grid1280ArticleCommentsTopTabUI props={props} /> : <PremiumArticleCommentsTopTabUI props={props} />
            AddCommentFormRender = (props: AddCommentFormRenderProps) => <PremiumAddCommentFormUI props={props} />
            ArticleCommentRender = (props: ArticleCommentRenderProps) => <PremiumArticleCommentUI props={props} />
        }

        else if (calcalist) {
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => <CalcalistArticleCommentsTopTabUI props={props} />
            AddCommentFormRender = (props: AddCommentFormRenderProps) => <CalcalistAddCommentFormUI props={props} />
            ArticleCommentRender = (props: ArticleCommentRenderProps) => <CalcalistArticleCommentUI props={props} />
        }


        else if (isFirmaDesign) {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => <AddCommentFormUI1280 props={props} />
            ArticleCommentRender = (props: ArticleCommentRenderProps) => <ArticleCommentUI1280 props={props} />
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => <ArticleCommentsTopTabUI1280 props={props} />
        }
        else if (isFirmaApp) {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => null,
                ArticleCommentRender = (props: ArticleCommentRenderProps) => version > 2 ? <ArticleCommentAppUI props={props} /> : null,
                ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => version > 2 ? <ArticleCommentsTopTabAppUI props={props} /> : null
        }
        else if (isFirmaMobileWeb) {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => null;
            ArticleCommentRender = (props: ArticleCommentRenderProps) => <ArticleCommentMobileWebUI props={props} />;
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => <ArticleCommentsTopTabMobileWebUI props={props} />;
            ArticleCommentsPopupRender = (props: MutamArticleCommentsPopupRenderProps) => <MutamArticleCommentsPopupUI props={props} />;
            limitComments = 3;
        }
        else if (isCalcalistMobileWeb) {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => null;
            ArticleCommentRender = (props: ArticleCommentRenderProps) => <ArticleCommentMobileCalcalistWebUI props={props} />;
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => <ArticleCommentsCalcalistTopTabMobileWebUI props={props} />;
            ArticleCommentsPopupRender = (props: MutamArticleCommentsPopupRenderProps) => <MutamArticleCommentsCalcalistPopupUI props={props} />;
            limitComments = 5;

        }
        else {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => <AddCommentFormYnetUI props={props} />
            ArticleCommentRender = (props: ArticleCommentRenderProps) => <ArticleCommentYnetUi props={props} />
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => <ArticleCommentsTopTabYnetUi props={props} />
        }
        let commentInTeaser = comments_template_2026 ? teaserComments : comments;
        const commentsToShow = limitComments && limitComments !== 0 ? take(commentInTeaser, limitComments) : commentInTeaser;
        const showAds = (displayType === "firmaApp" && version > 2) || (isGrid1280 && isYnetPlus) || displayType === "firmaMobileWeb";
        const script_display = isGptType && isGptType == "new" ? <script type="text/javascript" dangerouslySetInnerHTML={{ __html: `googletag.cmd.push(function() { googletag.display("ads.box"); });` }}></script> : "";
        const hideAdsBox = typeof window !== "undefined" && window.hideTalkbackBox ? window.hideTalkbackBox : false;
        return (
            <section className={(comments_template_2026 ? "comments_template_2026 " : "") + ((isFirmaApp || comments_template_2026_app) ? "SiteAppArticleComments" : `SiteArticleComments ${EnglishSiteCss}`) + (numOfComments === 0 ? " noComments" : "")} id="SiteArticleComments">
                {!blogArticleItem && <><ArticleCommentsTopTabWrapper
                    render={ArticleCommentsTopTabRender}
                    lang={lang}
                    isLtr={isLtr}
                    numOfComments={numOfComments}
                    numOfDiscussions={numOfDiscussions}
                    sortSelection={sortSelection}
                    areAllCommentsExpanded={areAllCommentsExpanded}
                    isAddCommentFormVisible={isAddCommentFormVisible}
                    expandAllComments={this.expandAllComments}
                    handleFormVisibility={this.handleFormVisibility}
                    handleSortSelection={this.handleSortSelection}
                    handleCommentsPopupVisibility={() => this.handleCommentsPopupVisibility()}
                    handleCommentsPopupClose={this.handleCommentsPopupClose}
                />

                    <AddCommentFormWrapper
                        render={AddCommentFormRender}
                        isAddCommentFormVisible={comments_template_2026 ? false : isAddCommentFormVisible}
                        lang={lang}
                        articleId={articleId}
                        shouldTitleBeHidden={comments_template_2026}
                        formType={"NEW"}
                        handleCloseCommentForm={this.handleCloseCommentForm}
                        isFirstComment={showFormWhenEmpty && numOfComments === 0}
                    /></>}


                {!blogArticleItem && <SimpleAttrRenderer className="commentsContainer" role={comments_template_2026_app ? "link" : "button"} isApp={comments_template_2026_app} href="go_to_all_comments" onClick={(!isFirmaApp && (comments_template_2026_desktop || comments_template_2026_mobile)) ? () => this.handleCommentsPopupOpen() : null}>
                    {(numOfComments === 0 && comments_template_2026) ? (comments_template_2026_app ? <a href="add_new_comment" className="noCommentsContainer"><span>{getTranslation(lang, "No comments yet, be the first to comment")}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5.80174 10.4731C6.06609 10.215 6.06609 9.79663 5.80174 9.53858L1.49399 5.33329L5.80174 1.12801C6.06609 0.869952 6.06609 0.451559 5.80174 0.193502C5.5374 -0.0645555 5.10881 -0.0645555 4.84446 0.193502L0.297389 4.63241C-0.0991288 5.0195 -0.0991288 5.64709 0.297389 6.03417L4.84446 10.4731C5.10881 10.7311 5.5374 10.7311 5.80174 10.4731Z" fill="black" />
                        </svg>

                    </a> : <div onClick={() => this.handleCommentsPopupVisibility()} className="noCommentsContainer"><span>{getTranslation(lang, "No comments yet, be the first to comment")}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5.80174 10.4731C6.06609 10.215 6.06609 9.79663 5.80174 9.53858L1.49399 5.33329L5.80174 1.12801C6.06609 0.869952 6.06609 0.451559 5.80174 0.193502C5.5374 -0.0645555 5.10881 -0.0645555 4.84446 0.193502L0.297389 4.63241C-0.0991288 5.0195 -0.0991288 5.64709 0.297389 6.03417L4.84446 10.4731C5.10881 10.7311 5.5374 10.7311 5.80174 10.4731Z" fill="black" />
                        </svg>

                    </div>) : commentsToShow.map((comment, i) =>
                        <div key={`comment_${comment.id}`}>
                            <ArticleCommentWrapper
                                render={ArticleCommentRender}
                                lang={lang}
                                IdOfLastTalkbackExpandedByUser={IdOfLastTalkbackExpandedByUser}
                                handleUpdateArticleCommentsStorageState={this.updateArticleCommentsStorageState}
                                isAutoExpanded={comments_template_2026 ? false : areAllCommentsExpanded}
                                articleId={articleId}
                                comment={comment}
                                handleCommentsPopupVisibility={() => this.handleCommentsPopupVisibility()}
                                isFirma={displayType === "firma"}
                                domain={domain}
                                isFirmaMobileWeb={displayType === "firmaMobileWeb"}
                                isNewTemplate2026={comments_template_2026}
                                handleCommentsPopupClose={this.handleCommentsPopupClose}
                                isAllCommentsPopupVisable={isAllCommentsPopupVisable}
                            />
                        </div>
                    )}
                </SimpleAttrRenderer>}

                {(isMobileWeb || comments_template_2026_mobile || comments_template_2026_desktop) &&
                    <MutamArticleCommentsPopupWrapper
                        render={ArticleCommentsPopupRender}
                        lang={lang}
                        articleId={articleId}
                        comments={comments}
                        isFirmaMobileWeb={isMobileWeb}
                        isAddCommentFormVisible={isAddCommentFormVisible}
                        IdOfLastTalkbackExpandedByUser={IdOfLastTalkbackExpandedByUser}
                        updateArticleCommentsStorageState={this.updateArticleCommentsStorageState}
                        areAllCommentsExpanded={areAllCommentsExpanded}
                        sortSelection={sortSelection}
                        numOfComments={numOfComments}
                        showFormWhenEmpty={showFormWhenEmpty}
                        handleCloseCommentForm={this.handleCloseCommentForm}
                        handleFormVisibility={this.handleFormVisibility}
                        isAllCommentsPopupVisable={isAllCommentsPopupVisable}
                        handleCommentsPopupClose={this.handleCommentsPopupClose}
                        handleSortSelection={(e) => this.handleSortSelection(e, 1)}
                        handleCommentsPopupVisibility={this.handleCommentsPopupVisibility}
                        isPopupClose={isPopupClose}
                        loadMoreComments={() => this.loadMoreComments(sortSelection, true)}
                        hasMore={hasMore}
                        postId={postId}
                        domain={domain}
                    />}
                {!blogArticleItem && <> {hasMore && (isFirmaApp || comments_template_2026_app) && version > 2 ? <a href={"go_to_all_comments"} className="showMoreCommentsButton-pf firmaApp">{comments_template_2026_app ? getTranslation(lang, "Show more") : " לכל התגובות"}</a> : null}
                    {((!hasMore && (isMobileWeb || comments_template_2026_mobile || comments_template_2026_desktop)) || hasMore) && (displayType !== "firmaApp") &&
                        <div className="showMoreCommentsButton" onClick={(isMobileWeb || comments_template_2026_desktop || comments_template_2026_mobile) ? () => this.handleCommentsPopupVisibility() : e => this.loadMoreComments()}>
                            {isCalcalistMobileWeb ? "לכל התגובות" : (comments_template_2026 ? getTranslation(lang, "Show more") : getTranslation(lang, "Load More Talkbacks"))}
                        </div>}
                    {showAds && !hideAdsBox && <div id="ads.box" className="CommentsBox">{script_display}</div>}
                    {!hasMore && page > 0 && !isMobileWeb && !comments_template_2026 &&
                        <div className="closeCommentsButton" onClick={this.onCloseCommentsBtnPress}>
                            {getTranslation(lang, "Close Talkbacks")}
                        </div>}</>}
            </section>
        )
    }
}


export const SimpleAttrRenderer: React.StatelessComponent<SimpleAttrRendererProps> = ({ href, className, children, title, isApp, onClick, role }) => {
    const tag = isApp ? "a" : "span";
    const props: any = isApp ? { href, className, title, role } : { className, onClick, title, role };
    return React.createElement(tag, props, children);
}

interface SimpleAttrRendererProps {
    href: string
    onClick: () => void
    className?: string
    children?: React.ReactNode
    target?: string
    title?: string
    style?: React.CSSProperties
    rel?: string
    ariaLabel?: string
    linkTarget?: string
    alt?: string
    isApp?: boolean
    role?: string
}